<template>
  <div class="product">
    <product-select :items="items" ref="main" />
  </div>
</template>

<script>
import ProductSelect from "../components/pages/ProductSelect.vue";

export default {
  name: "ProductSelectView",
  components: {
    ProductSelect,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  beforeRouteEnter(to, from, next) {
    const isFromInner = from.name === "Top" || from.name === "Comparison";
    isFromInner
      ? next((vm) => {
          if (from.name === "Top") vm.$refs.main.checkAll();
        })
      : next("/");
  },
};
</script>
